import './Navbar.css';
import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

class Navbar extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);

    this.state = {active: false};
  }

  handleChange = (e, value) => {

    this.setState({active: !this.state.active});
  };

    render() {


        return (
            <nav

                  id="navbar"
                  className="navbar">
                <div className="navbar-line">
                    <AnchorLink className={ this.state.active ? "active" : "" } offset='57'  href="#portfolio"  onClick={this.handleChange}
                    >portfolio</AnchorLink>
                    <AnchorLink className={ this.state.active ? "active" : "" } offset='57'  href="#skills"  onClick={this.handleChange}
                      >skills</AnchorLink>
                    <AnchorLink className={ this.state.active ? "active" : "" } offset='57'  href="#about"  onClick={this.handleChange}
                      >about</AnchorLink>
                </div>

            </nav>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js